import { Columns } from '@shared/interfaces/table/column-config';
import { MeteringPointDetails } from '@app/api/dmc';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const locationDetailsMasterData: Columns<MeteringPointDetails>[] = [
  {
    title: 'address.roadcode',
    key: 'installationLocationAddress.streetCode'
  },
  {
    title: 'address.streetName',
    key: 'installationLocationAddress.streetName'
  },
  {
    title: 'address.houseNumber',
    key: 'installationLocationAddress.buildingNumber'
  },
  {
    title: 'address.floor',
    key: 'installationLocationAddress.floorIdentification'
  },
  {
    title: 'address.door',
    key: 'installationLocationAddress.roomIdentification'
  },
  {
    title: 'address.city',
    key: 'installationLocationAddress.cityName'
  },
  {
    title: 'address.zipCode',
    key: 'installationLocationAddress.postalCode'
  },
  {
    title: 'address.postaldistrict',
    key: 'installationLocationAddress.subDivisionName',
  },
  {
    title: 'address.municipalcode',
    key: 'installationLocationAddress.municipalityCode'
  },
  {
    title: 'address.countrycode',
    key: 'installationLocationAddress.country'
  },
  {
    title: 'address.darReference',
    key: 'installationLocationAddress.darReference'
  },
  {
    title: 'meter.createform.comments',
    key: 'detailCharacteristics.locationDescription'
  },
  {
    title: 'address.washInstructions',
    key: 'installationLocationAddress.washInstructions',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'meteringpoint.location.washInstructions.notspecified',
      accessaddress: 'meteringpoint.location.washInstructions.accessaddress',
      residentialaddress: 'meteringpoint.location.washInstructions.residentialaddress',
      washable: 'meteringpoint.location.washInstructions.washable',
      notwashable: 'meteringpoint.location.washInstructions.notwashable'
    }
  }
];
